import React from 'react';
import { Button, Modal, Table } from 'react-bootstrap';
import { formatDowntimeHms, groupDowntimeByMachine } from './floorDeckUtils';

function formatPcs(value) {
    return Number(value || 0).toLocaleString();
}

// T1 Machine downtime behind the Floor Deck card. Rows arrive sorted by most downtime.
export default function MachineDowntimeModal({ show, onClose, date, submissions = [], totalSeconds = 0, totalPcs = 0 }) {
    const machines = groupDowntimeByMachine(submissions);
    return <Modal show={show} onHide={onClose} size="xl" scrollable aria-labelledby="machine-downtime-title">
        <Modal.Header closeButton><Modal.Title id="machine-downtime-title">Machine downtime - {date}</Modal.Title></Modal.Header>
        <Modal.Body>
            <p>
                Total T1 Machine downtime: <strong>{formatDowntimeHms(totalSeconds)}</strong> from {formatPcs(totalPcs)} pcs lost.
                Downtime = PCS loss × cycle time. Times are Malaysia time (UTC+8).
            </p>
            {submissions.length === 0 ? <p>No T1 Machine downtime for this date.</p> : <>
                <h3 className="h6">By machine</h3>
                <div style={{ overflowX: 'auto' }} tabIndex={0} role="region" aria-label="Downtime by machine">
                    <Table bordered size="sm" className="table-no-frozen-columns">
                        <thead><tr><th>Machine</th><th>T1 Machine (pcs)</th><th>Downtime</th></tr></thead>
                        <tbody>{machines.map((row) => <tr key={row.machine}>
                            <td>{row.machine}</td><td>{formatPcs(row.pcs)}</td><td>{formatDowntimeHms(row.seconds)}</td>
                        </tr>)}</tbody>
                    </Table>
                </div>
                <h3 className="h6">Submissions</h3>
                <div style={{ overflowX: 'auto' }} tabIndex={0} role="region" aria-label="Downtime submissions">
                    <Table bordered size="sm" className="table-no-frozen-columns" style={{ minWidth: 1000 }}>
                        <thead><tr>
                            <th>Time</th><th>Machine</th><th>Job No</th><th>Part No</th>
                            <th>T1 Machine (pcs)</th><th>Cycle time (s)</th><th>Downtime</th><th>Remark</th>
                        </tr></thead>
                        <tbody>{submissions.map((row, index) => <tr key={row.id ?? index}>
                            <td>{new Date(row.timestamp).toLocaleString('en-GB', { timeZone: 'Asia/Kuala_Lumpur', hour12: true })}</td>
                            <td>{row.machine}</td><td>{row.jobOrder || '-'}</td><td>{row.partNo || '-'}</td>
                            <td>{formatPcs(row.pcs)}</td><td>{row.cycleTime}</td><td>{formatDowntimeHms(row.seconds)}</td>
                            <td>{row.remark || '-'}</td>
                        </tr>)}</tbody>
                    </Table>
                </div>
            </>}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={onClose}>Close</Button></Modal.Footer>
    </Modal>;
}
